
export default {
	ACTIVATE:                        'Activer',
	ACTIVE:                          'Actif',
	ADD_CHECKBOX:                    'Cases à cocher',
	ADD_COMMUNICATION:               'Créer une actualité',
	ADD_COMMUNICATION_TUTO:          'Pour créer votre première actualité clickez sur "Créer une actualité".',
	ADD_DROP_DOWN:                   'Menu déroulant',
	ADD_MARKETER:                    'Créer un marketeur',
	ADD_MARKETER_TUTO:               'Pour créer votre première marketeur clickez sur "Créer un marketeur".',
	ADD_OPTION:                      'Ajouter une option',
	ADD_PASS:                        'Créer un pass',
	ADD_PASS_TUTO:                   'Pour créer votre première pass clickez sur "Créer un pass".',
	ADD_QUESTION:                    'Ajouter une question du type :',
	ADD_RADIO:                       'Choix multiple',
	ADDRESS:                         'Adresse',
	ADD_STAR_RATING:                 'Note par étoile',
	ADD_STORE:                       'Créer un magasin',
	ADD_SURVEY:                      'Créer une enquête',
	ADD_SURVEY_TUTO:                 'Pour créer votre première enquête clickez sur "Créer une enquête".',
	ADD_TEMPLATE:                    'Créer un modèle d\'email',
	ADD_TEMPLATE_NAME:               'Nom du modèle d\'email',
	ADD_TEMPLATE_TUTO:               'Pour créer votre première modèle d\'email clickez sur "Créer un modèle d\'email".',
	ADD_TEXT_AREA:                   'Paragraphe',
	ADD_TEXT:                        'Réponse courte',
	ADD_ZONE:                        'Créer une zone',
	AGE:                             'Age',
	ALL_COMMENTS:                    'Tous',
	ALL_RATINGS:                     'Tous',
	ALL_STORES:                      'Tous les magasins',
	ALL_ZONES:                       'Toutes les zones',
	ARE_YOU_SURE:                    'Êtes-vous sûr ?',
	AT:                              'à',
	BACK:                            'Retour',
	BARCODE:                         'Code bar',
	BG_COLOR:                        'Couleur de fond',
	BOUNCED_EMAIL:                   'Adresses e-mail invalides / eronnées',
	BRAND:                           'Marque',
	BRAND_NAME_MANDATORY:            'Le nom de la marque est obligatoire',
	CANCEL:                          'Annuler',
	CAN_PUBLISH:                     'Droit de publication',
	CAN_WRITE:                       'Droit d\'écriture',
	CART:                            'Panier',
	CHANGE_PASSWORD:                 'Changer le mot de passe',
	CHECKBOX:                        'Cases à cocher',
	CHOOSE_IMAGE:                    'Choisir une image',
	COLOR:                           'Couleur',
	COMMENTS:                        'Commentaires',
	COMMUNICATION:                   'Communication',
	COMMUNICATIONS:                  'Communications',
	CONDITION_EQUAL:                 'égal (parente)',
	CONDITION_EQUAL_PREVIOUS:        'égal (précédente)',
	CONDITION_GREATER_THAN:          'plus grand que (parente)',
	CONDITION_LOWER_THAN:            'plus petit que (parente)',
	CONDITION_NO:                    'sans condition',
	CONTACT_MID_MANGOOTRUST_TEXT:    'Les pages mangootrust ne peuvent pas être supprimées. Veuillez contacter la hotline',
	CONTACT_MID_MANGOOTRUST_TITLE:   '',
	CONTENT:                         'Contenu',
	COVER:                           'Image de couverture mangootrust* (16:9)',
	CREATE:                          'Créer',
	CREATED_AT:                      'Date de création',
	CREATED_BY:                      'Créateur',
	CREATE_ZONE:                     'Créer une zone',
	CURRENT_QUESTIONS:               'Questions',
	CUSTOMERS:                       'Client',
	DEACTIVATE:                      'Désactiver',
	DEMAT_PERCENTAGE:                'Taux de dématérialisation',
	DESCRIPTION:                     'Description',
	DESCRIPTION_LOCK:                'Description sur l\'écran verrouillé',
	DESCRIPTION_MANDATORY:           'La description est obligatoire',
	DESIGNATION:                     'Désignation',
	DETAIL:                          'Détail des notes',
	DETAIL_INFO:                     'Détail',
	DETAILS:                         'Détails',
	DETRACTORS:                      'Détracteurs',
	DIGITAL_RECEIPT:                 'Tickets de caisse',
	DONT_DISPLAY:                    'Ne pas afficher',
	DOWNLOAD_CLIENT_BASE:            'Télécharger la Base Cliente',
	DOWNLOAD_THE_LIST:               'Télécharger la liste',
	DROP_DOWN:                       'Menu déroulant',
	EDIT:                            'Modifier',
	EDIT_ZONE:                       'Modifier la zone',
	EMAIL_AND_PRINT:                 'Email et papier',
	EMAILCOUNT:                      'Nombre d\'émails',
	EMAIL_COVER_IMAGE:               'Image de coverture pour le mail',
	EMAIL_COVER_LINK:                'Lien de l\'image de couverture pour le mail',
	EMAIL:                           'Email',
	EMAIL_MANDATORY:                 'L\'email est obligatoire',
	EMAIL_ONLY:                      'Email seulement',
	EMAILS:                          'Emails',
	EMAIL_WITHOUT_RECEIPT:           'Email sans ticket',
	END_DATE:                        'Date de fin',
	EXCLUSIVE_OFFER:                 'Offre exclusive',
	FACEBOOK:                        'Facebook',
	FAVORITES:                       'Favoris',
	FG_COLOR:                        'Couleur du text',
	FOLLOWERS:                       'Followers',
	FORGOT_PASSWORD_QUESTION:        'Mot de passe oublié ?',
	GENERAL:                         'Général',
	GLOBAL_INFO:                     'Global',
	GLOBAL_RATING:                   'Note du magasin',
	IMAGE:                           'Image',
	INDICATORS:                      'Indicateurs',
	INSTAGRAM:                       'Instagram',
	LINKS:                           'Liens',
	LOGIN:                           'Valider',
	LOGO_COVER_EXPLANATION:          '*Cette image de couverture sera présente sur les éventuelles pages publiques où sont mis en valeur les commentaires (sur <a href="{{brand.mangootrustUrl}}" target="_blank">{{brand.mangootrustUrl}}</a>).',
	LOGO:                            'Logo*',
	LOGOUT:                          'Déconnecter',
	MANGOOTRUST_LINK:                'Lien mangootrust',
	MANGOOTRUST:                     'mangootrust',
	MARKETER:                        'Marketeur',
	MARKETERS:                       'Marketeurs',
	MEN:                             'Homme',
	NAME_MANDATORY:                  'Le nom est obligatoire',
	NAME:                            'Nom',
	NEW_EMAIL:                       'Nouvelle adresse email',
	NO_COMMUNICATION:                'Pas de pass',
	NO_DATA:                         'Pas de réponse',
	NO_MARKETER:                     'Pas de marketeur',
	NO:                              'Non',
	NO_PASS:                         'Pas de pass',
	NO_PRODUCT:                      'Pas de produit',
	NO_RECEIPTS:                     'Pas de tickets',
	NO_REVIEW:                       'Pas de note',
	NO_STORE:                        'Pas de magasin',
	NO_SURVEY:                       'Pas d\'enquête',
	NO_TEMPLATE:                     'Pas de modèle d\'email',
	NOTES:                           'Notes des produits',
	NOTIFICATION_EMAILS_FOR:         'Notifications pour',
	NOT_SENT:                        'PDF en cours de génération',
	NPSVALUE:                        'NPS',
	OLD_QUESTIONS:                   'Questions supprimées',
	OPTOUTS:                         'Opt-outs',
	PASSIVES:                        'Passifs',
	PASS:                            'Pass',
	PASSWORD:                        'Mot de passe',
	PEOPLE_FOLLOWING_YOUR_BRAND:     'Nombre de personnes suivant votre marque',
	PHONE:                           'Téléphone',
	PICTURE:                         'Photo',
	PINNED_COMMUNICATIONS:           'Épinglées',
	PINNED_COUNT:                    'Actualité épinglée',
	POSITION:                        'Position',
	PREFERENCES:                     'Préférences',
	PREVIEW:                         'Aperçu',
	PRINT_AND_EMAIL:                 'Papier et email',
	PRINT_ONLY:                      'Papier seulement',
	PRODUCT_RATING:                  'Note du produit',
	PROMOTERS:                       'Promoteurs',
	PUBLISH_ALL_MANGOOTRUST:         'Avis de toutes les boutiques publiées sur www.mangootrust.com',
	PUBLISH_ALL_MANGOOTRUST_TEXT:    'Vous allez publier les pages pour vos boutiques sur mangootrust. Une fois publiées, la suppression de ces pages ne sera pas possible',
	PUBLISH_TEMPLATE:                'Publier le modèle d\'email',
	PUBLISH:                         'Publication',
	PURCHASED_ON:                    'Achat effectué le',
	QUESTION_ACTIVATE_SURVEY:        'Vous êtes sur le point d\'activer l\'enquête',
	QUESTION_DEACTIVATE_SURVEY:      'Vous êtes sur le point de désactiver l\'enquête',
	QUESTION_DELETE_COMMUNICATION:   'Vous êtes sur le point de supprimer la actualité',
	QUESTION_DELETE_MARKETER:        'Vous êtes sur le point de supprimer',
	QUESTION_DELETE_QUESTION:        'Vous êtes sur le point de supprimer la question',
	QUESTION_DELETE_SURVEY:          'Vous êtes sur le point de supprimer l\'enquête',
	QUESTION_DELETE_TEMPLATE:        'Vous êtes sur le point de supprimeri le modèle d\'email',
	QUESTION_DELETE_ZONE:            'Vous êtes sur le point de supprimer la zone',
	QUESTION_SEEN_BY_CUSTOMER:       'Question que vos clients vont voir',
	RADIO:                           'Choix multiple',
	RANKING:                         'Classement',
	RATED_ON:                        'Partagé le',
	RATINGAVG:                       'Note moyenne',
	RATINGCOUNT:                     'Nombre de notes',
	RATINGS:                         'Notes',
	RATING_SPLIT:                    'Répartition des notes',
	READ_COMMUNICATIONS:             'Lues',
	READ_COUNT:                      'Actualité lue',
	RECEIPT_FOOTER_IMAGE:            'Image de pied de ticket',
	RECEIPT_HEADER_IMAGE:            'Image de tête de ticket',
	RECEIPT:                         'Ticket de caisse dématérialisé',
	REFERENCE:                       'Référence',
	REMOVE_QUESTION:                 'Supprimer question',
	REMOVE:                          'Supprimer',
	REMOVE_ZONE:                     'Supprimer la zone',
	REPLIED_ON:                      'Répondu le',
	REPLY:                           'Répondre',
	REPLY_TO_COMMENT:                'Réponse au commentaire',
	RESPONSE:                        'Réponse',
	RESPONSES:                       'Réponses',
	REVENUE:                         'Chiffre d\'affaire',
	REVIEWS_COUNT:                   'note(s)',
	REVIEWS:                         'Notes des magasins',
	SALE_ON:                         'Achat effectué le',
	SAVE:                            'Enregistrer',
	SEARCH:                          'Rechercher',
	SENT_COMMUNICATIONS:             'Envoyées',
	SENT:                            'PDF généré',
	SETTINGS:                        'Paramétrage',
	SHOW_IN_STORE:                   'A présenter en magasin',
	SOME_ZONES:                      'Sélectionnez des zones',
	STAR_RATING:                     'Note par étoile',
	START_DATE:                      'Date de début',
	STATS:                           'Résultats',
	STOREID:                         'Position',
	STORE:                           'Magasin',
	STORENAME:                       'Nom',
	STORES:                          'Magasins',
	STORES_RATING:                   'Note des magasins',
	SUBJECT:                         'Sujet',
	SUMMARY:                         'Tableau de bord',
	SUPER:                           'Super',
	SURVEY_CREATION:                 'Enquête création',
	SURVEY:                          'Enquête',
	SURVEYS:                         'Enquêtes',
	SURVEY_STATS:                    'Résultats de l\'enquête :',
	TAKEN_EMAILS:                    'Nouveaux emails',
	TEMPLATE:                        'Modèle d\'email',
	TEMPLATES:                       'Modèles d\'emails',
	TEXT_AREA:                       'Paragraphe',
	TEXT:                            'Réponse courte',
	TIMES_YOUR_BRAND_HAS_BEEN_LIKED: 'Nombre de like de votre marque',
	TITLE:                           'Titre',
	TUTORIAL:                        'Tutorial',
	TWITTER:                         'Twitter',
	TYPE:                            'Type',
	UPDATED_AT:                      'Date de modification',
	VALID_UNTIL:                     'Valide jusqu\'au',
	VALUE_OF_AVERAGE_CART:           'Panier moyen',
	VIEW_RECEIPT:                    'Voir le ticket',
	VIEW_SURVEY:                     'Voir l\'enquête',
	VISUAL:                          'Visuels',
	WEBSITE:                         'Site web',
	WITH_COMMENTS_ONLY:              'Seulement avec des commentaires',
	WITH_COMMENTS:                   'Oui',
	WITHOUT_COMMENTS:                'Non',
	WOMEN:                           'Femme',
	WRITE:                           'Écriture',
	WRITE_YOUR_REPLY:                'Écrivez votre réponse',
	YES:                             'Oui',
	YOURNOTES:                       'Notes de vos produits',
	ZONES:                           'Zones',
	ZONE:                            'Zone',
};



// WEBPACK FOOTER //
// ./src/translation/fr.js